import React, { useEffect, useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography, Box, CircularProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';
import AccountRepository from '../../../store/repository/AccountRepository';
const FailedAttemptsPopup = ({ isOpen, onClose, accountId }) => {
    const { t } = useTranslation();
    const [failedAttempts, setFailedAttempts] = useState([]);
    const [loading, setLoading] = useState(false);
    const [unlocking, setUnlocking] = useState(false);
    useEffect(() => {
        if (isOpen && accountId) {
            fetchFailedAttempts();
        }
    }, [isOpen, accountId]);
    const fetchFailedAttempts = async () => {
        if (!accountId)
            return;
        setLoading(true);
        try {
            const response = await AccountRepository.getFailedAttempts(accountId);
            if (response.data && response.data.value) {
                setFailedAttempts(response.data.value);
            }
        }
        catch (error) {
            console.error('Error fetching failed attempts:', error);
        }
        finally {
            setLoading(false);
        }
    };
    const handleUnlockAccount = async () => {
        if (!accountId)
            return;
        setUnlocking(true);
        try {
            await AccountRepository.unlockAccount(accountId);
            // Close the popup and refresh
            onClose();
        }
        catch (error) {
            console.error('Error unlocking account:', error);
        }
        finally {
            setUnlocking(false);
        }
    };
    const formatDate = (dateString) => {
        // Backend sends UTC time, convert to user's local time
        // If the date string doesn't have 'Z' or timezone info, treat it as UTC
        let utcDateString = dateString;
        if (!dateString.endsWith('Z') && !dateString.includes('+') && !dateString.includes('T')) {
            // Format: "2025-10-24T20:39:43" without timezone
            utcDateString = dateString + 'Z';
        }
        else if (dateString.includes('T') && !dateString.endsWith('Z') && !dateString.includes('+') && !dateString.includes('-', 11)) {
            // ISO format without timezone indicator
            utcDateString = dateString + 'Z';
        }
        const date = new Date(utcDateString);
        return date.toLocaleString();
    };
    return (React.createElement(Dialog, { open: isOpen, onClose: onClose, maxWidth: "lg", fullWidth: true },
        React.createElement(DialogTitle, null,
            React.createElement(Typography, { variant: "h5" }, t('Failed Login Attempts'))),
        React.createElement(DialogContent, null, loading ? (React.createElement(Box, { display: "flex", justifyContent: "center", padding: 4 },
            React.createElement(CircularProgress, null))) : failedAttempts.length === 0 ? (React.createElement(Typography, { align: "center", padding: 4 }, t('No failed attempts found'))) : (React.createElement(TableContainer, { component: Paper, style: { maxHeight: 500 } },
            React.createElement(Table, { stickyHeader: true },
                React.createElement(TableHead, null,
                    React.createElement(TableRow, null,
                        React.createElement(TableCell, null,
                            React.createElement("strong", null, t('Date & Time'))),
                        React.createElement(TableCell, null,
                            React.createElement("strong", null, t('Last Name'))),
                        React.createElement(TableCell, null,
                            React.createElement("strong", null, t('Birthdate'))))),
                React.createElement(TableBody, null, failedAttempts.map((attempt) => {
                    const lastNameMatch = attempt.lastName?.toLowerCase() === attempt.correctLastName?.toLowerCase();
                    const birthdateMatch = new Date(attempt.birthdate).toDateString() ===
                        new Date(attempt.correctBirthdate).toDateString();
                    return (React.createElement(TableRow, { key: attempt.id },
                        React.createElement(TableCell, null, formatDate(attempt.attemptDateTime)),
                        React.createElement(TableCell, null,
                            React.createElement("div", { style: { color: lastNameMatch ? 'green' : 'red' } },
                                React.createElement("strong", null,
                                    t('Entered'),
                                    ":"),
                                " ",
                                attempt.lastName),
                            !lastNameMatch && (React.createElement("div", { style: { color: 'gray', fontSize: '0.85em' } },
                                React.createElement("strong", null,
                                    t('Expected'),
                                    ":"),
                                " ",
                                attempt.correctLastName || '-'))),
                        React.createElement(TableCell, null,
                            React.createElement("div", { style: { color: birthdateMatch ? 'green' : 'red' } },
                                React.createElement("strong", null,
                                    t('Entered'),
                                    ":"),
                                " ",
                                new Date(attempt.birthdate).toLocaleDateString()),
                            !birthdateMatch && attempt.correctBirthdate && (React.createElement("div", { style: { color: 'gray', fontSize: '0.85em' } },
                                React.createElement("strong", null,
                                    t('Expected'),
                                    ":"),
                                " ",
                                new Date(attempt.correctBirthdate).toLocaleDateString())))));
                })))))),
        React.createElement(DialogActions, null,
            React.createElement(Button, { onClick: handleUnlockAccount, color: "primary", variant: "contained", disabled: unlocking }, unlocking ? React.createElement(CircularProgress, { size: 20 }) : t('Unlock Account')),
            React.createElement(Button, { onClick: onClose, color: "secondary" }, t('Close')))));
};
export default FailedAttemptsPopup;
